module.exports = __webpack_public_path__ + "img/des_piano_02.913643a8.jpg";